import React from 'react';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';

import { useParcoursFormalite } from '../provider';

export type CurrentFormalityAndClientProps = {
    currentCatalogOnly?: boolean;
};

const CurrentFormalityAndClient: React.FunctionComponent<CurrentFormalityAndClientProps> =
    function ({ currentCatalogOnly = false }) {
        const { currentCatalog, currentSousClient, currentCatalogs } = useParcoursFormalite();

        return (
            <Box
                sx={{
                    with: '100%',
                    textAlign: 'center',
                }}
            >
                <Typography
                    variant="l2dbodyxs"
                    color="text.secondary"
                    sx={{
                        fontWeight: 500,
                        fontStyle: 'italic',
                    }}
                >
                    {' '}
                    {currentCatalog && currentCatalogOnly
                        ? currentCatalog.nomCommercial
                        : null}{' '}
                    {currentCatalogs && !currentCatalogOnly
                        ? currentCatalogs.map((cata) => cata.nomCommercial).join(' - ')
                        : null}{' '}
                    {currentSousClient ? ` - ${currentSousClient.raisonSociale}` : ''}
                </Typography>
            </Box>
        );
    };

export default CurrentFormalityAndClient;
